
import React from "react";
import { Calendar } from "primereact/calendar";
import { Label } from "./NouveauVoyageurCss";
import { Controller, useFormContext } from "react-hook-form";

export default function InputCalendrier({ label, name }) {
    const { control } = useFormContext();
    return (
            <>
                <Label className="mb-1">{label}</Label>
                <Controller
                    name={name}
                    control={control}
                    render={({ field }) => (
                    <Calendar
                        id={name}
                        {...field}
                        onChange={(e) => field.onChange(e.value)}
                        value={field.value}
                        className={field.error ? "p-invalid" : ""}
                        showIcon
                    />
                    )}
                />
                {/* <Calendar value={date} onChange={(e) => setDate(e.value)} showIcon /> */}
            </>
    )
}